<template>
  <d-card
    :class="[
      'card-small d-inline-flex',
      { show: show, 'open-below': openBelow },
    ]"
    :style="{ top: `${positionTop}px`, left: `${positionLeft}px` }"
  >
    <d-card-body class="px-2 py-0">
      <d-form-row>
        <d-col class="form-group">
          <label>Direção <small>a partir da primeira letra</small></label>
          <d-select v-model="cell.direction" @change="changeDirection">
            <option value="">Selecione qual a direção de preenchimento</option>
            <option
              :value="option"
              v-for="option in optionsAvallable"
              :key="option.id"
            >
              {{ option.name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
    </d-card-body>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import modalPositionMixin from '_common/mixins/modalPositionMixin';
import {
  CELL,
  CELL_SIZE,
  _PUZZLE_SET_ANSWER_,
  _PUZZLE_ANSWER_OPTION_,
} from '../PuzzleModel';

const ANSWER_CELL_OFFSET_TOP = 68;
const ANSWER_CELL_OFFSET_LEFT = 110;

export default {
  name: 'puzzle-option-answer-modal',
  mixins: [modalPositionMixin],
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        return puzzle;
      }
      return false;
    },
    directions() {
      const { answerDirections } = this.$store.state.puzzle;
      if (answerDirections) {
        return answerDirections;
      }
      return [{ id: null, name: null, slug: null }];
    },
    optionsAvallable() {
      return this.directions.filter(item => {
        if (item.slug) {
          const direction = item.slug.split('_');
          const initial = direction[0];
          const last = direction.pop();
          if (this.puzzle) {
            return (
              this[initial](item) &&
              this[last](item) &&
              this.mergedCell(direction, item)
            );
          }
        }
        return false;
      });
    },
  },
  data() {
    return {
      disabled: true,
      cell: cloneDeep(CELL),
    };
  },
  methods: {
    ...mapActions(['getAnswerDirections', 'setHasChanges']),
    mergedCell(direction, item) {
      if (direction[1] && direction[1].includes('second')) {
        if (
          Number.isNaN(Number(this.cell.positiony)) ||
          this.cell.type.includes('rowspan') ||
          Number.isNaN(Number(this.cell.positionx)) ||
          this.cell.type.includes('colspan')
        ) {
          return item;
        }
        return false;
      }
      return item;
    },
    top(item) {
      let { positiony } = this.cell;
      if (Number.isNaN(Number(positiony))) {
        positiony = Number(positiony.split('_').shift());
      }
      if (parseInt(positiony, Number) !== 0) {
        return item;
      }
      return false;
    },
    bottom(item) {
      let { positiony } = this.cell;
      if (Number.isNaN(Number(positiony))) {
        positiony = Number(positiony.split('_').shift());
      }
      if (parseInt(positiony, Number) < parseInt(this.puzzle.rows, Number)) {
        return item;
      }
      return false;
    },
    right(item) {
      if (
        parseInt(this.cell.positionx, Number) <
        parseInt(this.puzzle.columns, Number)
      ) {
        return item;
      }
      return false;
    },
    left(item) {
      if (parseInt(this.cell.positionx, Number) !== 0) {
        return item;
      }
      return false;
    },
    getOptions() {
      if (!this.$store.state.puzzle.answerDirections) {
        this.getAnswerDirections();
      }
    },
    changeDirection() {
      setTimeout(() => {
        if (this.cell.direction) {
          this.cell.direction_id = this.cell.direction.id;
          Events.$emit(_PUZZLE_SET_ANSWER_, this.cell);
          this.setHasChanges(true);
          this.close();
        }
      }, 20);
    },
  },
  mounted() {
    this.getOptions();
    this.registerModalEvents(_PUZZLE_ANSWER_OPTION_, (cell, cellRect) => {
      this.cell = cell;
      this.show = true;
      if (cellRect) {
        this.applyPosition(cellRect);
      } else {
        this.openBelow = false;
        this.positionTop = cell.positiony * CELL_SIZE - ANSWER_CELL_OFFSET_TOP;
        this.positionLeft =
          cell.positionx * CELL_SIZE + CELL_SIZE / 2 - ANSWER_CELL_OFFSET_LEFT;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
$bgColor: #d7d7d7;
.card-small {
  visibility: hidden;
  transform: translateY(-100%);
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1199;
  transition: all 0.5 ease-in;
  background: $bgColor;
  width: 230px;
  &:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: $bgColor transparent transparent transparent;
  }
  &.open-below {
    transform: none;
  }
  &.open-below:before {
    top: auto;
    bottom: 100%;
    border-color: transparent transparent #d7d7d7 transparent;
  }
  &.show {
    visibility: visible;
    transition: all 0.5 ease-in;
  }
}
</style>
